<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Libellé <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="libelle" placeholder="Libellé du compte">
          <span *ngIf="submit && f.libelle.errors?.required" class="text-danger">Le libellé est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Numéro de compte</label>
          <input type="text" class="form-control" formControlName="numero" placeholder="Numéro">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="type">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Banque</label>
          <input type="text" class="form-control" formControlName="banque" placeholder="Nom de la banque">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>IBAN</label>
          <input type="text" class="form-control" formControlName="iban" placeholder="IBAN">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Solde initial</label>
          <input type="number" class="form-control" formControlName="soldeInitial">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Statut</label>
          <select class="form-control" formControlName="statut">
            <option *ngFor="let s of statuts" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
